// src/components/Minihome/widgets/TextBoxWidget.jsx

import { Box } from '@mui/material';
import ReactMarkdown from 'react-markdown';
// 2단계에서 생성할 CSS 파일을 임포트합니다.
import './TextBoxWidget.css';

export default function TextBoxWidget({ item }) {
    // 위젯 설정에서 textConfig를 가져옵니다.
    const { textConfig } = item;
    const content = textConfig?.content || '텍스트를 입력하세요... 📝';
    // 👇 textAlign 값을 가져오고, 없으면 'left'를 기본값으로 사용합니다.
    const textAlign = textConfig?.textAlign || 'left';

    return (
        <Box
            className="textbox-widget-content"
            sx={{
                p: 2,
                height: '100%',
                boxSizing: 'border-box',
                overflowY: 'auto',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                // 👇 textAlign 스타일을 적용합니다.
                textAlign: textAlign,
            }}
        >
            <ReactMarkdown>
                {content}
            </ReactMarkdown>
        </Box>
    );
}